import { useState } from 'react';
import { FormControl, FormLabel, Select, VStack, Text } from '@chakra-ui/react';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import Modal from '@/trio-ui/Modal';

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { crawlDepth: number }) => Promise<void>;
  siteUrl?: string;
};

const NewAuditModalComponent = function ({ open, onClose, onSubmit, siteUrl }: Props): JSX.Element {
  const [crawlDepth, setCrawlDepth] = useState(3);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await onSubmit({ crawlDepth });
      setCrawlDepth(3);
    } finally {
      setSubmitting(false);
    }
  };

  const body = (
    <VStack spacing={4} align="stretch">
      {siteUrl && (
        <Text fontSize="sm" color="gray.600">
          Crawling <strong>{siteUrl}</strong>
        </Text>
      )}
      <FormControl>
        <FormLabel fontSize="sm">Crawl Depth</FormLabel>
        <Select
          value={crawlDepth}
          onChange={(e) => setCrawlDepth(Number(e.target.value))}
        >
          {[1, 2, 3, 4, 5].map((d) => (
            <option key={d} value={d}>
              {d} {d === 1 ? 'level' : 'levels'} — ~{d === 1 ? '10' : d === 2 ? '25' : d === 3 ? '40' : '50'} pages
            </option>
          ))}
        </Select>
      </FormControl>
    </VStack>
  );

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      modalTitle="New Site Audit"
      headerIcon={BugReportOutlinedIcon}
      bodyRender={body}
      onConfirmClick={handleSubmit}
      onConfirmLabel={submitting ? 'Starting...' : 'Start Audit'}
      isButtonDisabled={submitting}
      isLoading={submitting}
      isCentered
      size="md"
    />
  );
};

export default NewAuditModalComponent;
